import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Megaphone } from "lucide-react";

/** Global announcement marquee — thin gold band above the product ticker.
 *  Admin edits announcements at /admin/docs. Auto-refreshes every 90s.
 */
export default function AnnouncementBar() {
  const [items, setItems] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    const load = () => api.get("/announcements").then((r) => setItems(r.data || [])).catch(() => {});
    load();
    const iv = setInterval(load, 90000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(iv); window.removeEventListener("focus", onFocus); };
  }, []);

  if (!items.length) return null;
  return (
    <div data-testid="announcement-bar" className="bg-gold text-royal border-b border-gold-deep overflow-hidden">
      <div className="flex items-stretch">
        <div className="shrink-0 hidden sm:flex items-center gap-2 bg-royal text-gold px-4 py-1 text-[10px] uppercase tracking-[0.3em] font-medium">
          <Megaphone size={12} /> Announcement
        </div>
        <div ref={ref} className="marquee-track flex-1 overflow-hidden group">
          <div className="animate-marquee flex gap-16 py-1 w-max group-hover:[animation-play-state:paused]">
            {[...items, ...items].map((a, i) => (
              <div key={`${a.id}-${i}`} data-testid={`announcement-${a.id}`} className="text-[12px] whitespace-nowrap font-medium tracking-wide">
                ★ {a.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
